import { LoginComponents, RegisterComponents } from "components"
import { CSvgLogo } from "icon"
import { useState } from "react"
import LoginImg from '../../media/auth/1.webp'
import RegisterImg from '../../media/auth/3.jpg'

export const Auth = () => {
    const [typePage, setTypePage] = useState<string>('login')

    return (
        <div className="w-full md:min-h-screen min-h-fit relative flex justify-center bg-hoory-125 items-center overflow-hidden">
            <div className='w-full max-w-2xl md:h-[600px] h-full  md:shadow shadow-none bg-hoory-100 flex flex-wrap overflow-hidden rounded-md'>
                {/* <div className='w-full md:w-6/12 h-full relative md:flex hidden overflow-hidden '>
                    <span className='absolute left-0 right-0 bottom-0 top-0 bg-[#00000057] z-[2]'></span>
                    <img src={LoginImg} className={`w-full h-full object-cover object-center absolute transition-all duration-700 ${typePage == 'login' ? 'z-[1] top-0 opacity-100' : 'z-[-1] top-[-20px] opacity-0'}`} alt='auth' />
                    <img src={RegisterImg} className={`w-full h-full object-cover object-center absolute transition-all duration-700 ${typePage == 'register' ? 'z-[1] top-0 opacity-100' : 'z-[-1] top-[-20px] opacity-0'}`} alt='auth' />
                </div> */}
                <div className='w-full  h-full p-[20px]'>
                    <div className='w-full flex flex-col m-auto max-w-[400px] '>
                        <div className='w-full flex flex-col items-center justify-center '>
                            <CSvgLogo className="w-[40px] " />
                            <span className='my-2'>Welcome to Ai</span>
                            <div className="w-[200px] h-[40px] flex items-center justify-between rounded-full border border-hoory-75 shadow mt-4 p-1">
                                <button onClick={() => { setTypePage('login') }} type="button" className={`w-full h-full bg-pos-100 rounded-full flex items-center justify-center transition-all text-xs ${typePage == 'login' ? 'bg-hoory-200 text-white ' : 'bg-hoory-100 text-pos-25'}`}>Login</button>
                                <button onClick={() => { setTypePage('register') }} type="button" className={`w-full h-full bg-pos-100 rounded-full flex items-center justify-center transition-all text-xs ${typePage == 'register' ? 'bg-hoory-200 text-white ' : 'bg-hoory-100 text-pos-25'}`}>Register</button>
                            </div>
                        </div>
                    </div>
                    <div className="w-full  flex flex-col relative overflow-hidden">
                        {typePage == 'login' ?
                            <LoginComponents />
                            :
                            <RegisterComponents />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}